<div class="container-fluid">
  <app-learning-activities-table></app-learning-activities-table>
</div>
